export const defaultAnamnesis = `- Edad:
- FUR:
- Cargo y tiempo de exposición al riesgo:
- Antecedentes médicos personales (-), fármacos en uso (-), alergias (-), antecedentes quirúrgicos (-), antecedentes familiares (-)
- Fuma: Si/No
- Tuvo COVID: Si/No`;